<template>
    <v-btn
        v-if="size==='small'"
        outlined
        small
        :color="color"
        :loading="loading"
        @click.stop="onClick()"
    >
        {{buttonText}}
    </v-btn>
    <v-btn
        v-else-if="size==='x-small'"
        outlined
        x-small
        :color="color"
        :loading="loading"
        @click.stop="onClick()"
    >
        {{buttonText}}
    </v-btn>
    <v-btn
        v-else-if="size==='x-large'"
        outlined
        x-large
        :color="color"
        :loading="loading"
        @click.stop="onClick()"
    >
        {{buttonText}}
    </v-btn>
    <v-btn
        v-else-if="size==='large'"
        outlined
        large
        :color="color"
        :loading="loading"
        @click.stop="onClick()"
    >
        {{buttonText}}
    </v-btn>
    <v-btn
        v-else
        outlined
        :color="color"
        :loading="loading"
        @click.stop="onClick()"
    >
        {{buttonText}}
    </v-btn>
</template>

<script>

export default {
    props: {
        buttonText: {
            type: String,
            default: "Click"
        },
        color: {
            type: String,
            default: "primary"
        },
        size: {
            type: String,
            default: "medium"
        },
        loading: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        
    },
    data() {
        return {
            
        };
    },
    methods: {
        onClick() {
            this.$emit('onClick');
        }
    }
};
</script>

<style>
</style>